import { css } from 'linaria';

export namespace Styles {
  export const formSubmitThanks = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 80px;
    padding-bottom: 168px;
  `;

  export const thanksMainPhoto = css`
    width: 80px;
    height: 80px;
    object-fit: contain;
  `;

  export const thanksH1 = css`
    margin-top: 32px;
  `;

  export const thanksMessage = css`
    padding: 0px 5px 0px 5px;
    margin-top: 16px;
    text-align: center;
  `;

  export const thanksAction = css`
    width: 202px;
    margin-top: 32px;
  `;
}
